@if (items$ | async; as items) {
  @if (items.manuals; as manuals) {
    <mat-expansion-panel
      class="product-manual-panel"
      [ngClass]="activeLanguage$ | async"
      [style.display]="manuals.categorizedManualsList.length > 0 ? 'block' : 'none'"
      >
      <mat-expansion-panel-header class="pdp-manual-panel-header">
        <mat-panel-title #matPanelClick class="pdp-manual-label">
          {{ 'pdpManual.manualInstructionLabel' | cxTranslate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (manual of manuals.categorizedManualsList; track manual) {
        <p class="pdp-manual-category">
          <span>{{ manual.categoryType }}</span>
          @for (data of manual.manualsList.medias; track data) {
            <p>
              <app-generic-link
                [target]="'_blank'"
                [ngClass]="data.styleClass"
                [url]="data.media"
                [style]="data.styleAttributes"
                >{{ data.title }}</app-generic-link
                >
              </p>
            }
          </p>
        }
      </mat-expansion-panel>
    }
  }
